import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as Chart from 'chart.js';
import * as jsPDF from 'jspdf';
import { Observable } from 'rxjs';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-fact',
  templateUrl: './fact.component.html',
  styleUrls: ['./fact.component.scss']
})
export class FactComponent implements OnInit {

  @ViewChild('content',{static: false}) content: ElementRef;

  chart1; chart2;

  items: Array<any> = [];
  salas: any[] = [];
  dataset_salas = [];

  date_desde: string = new Date().toISOString().slice(0, 10);
  date_hasta: string = new Date().toISOString().slice(0, 10);

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_desde = dateStr
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.date_hasta = dateStr;
      console.log(dateStr);
    }
  };

  constructor(public rest: RestService) {}

  ngOnInit() {}

  private mixedChart(nombre, textTitle, labels, dataset_salas) {

    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: labels,
        datasets: dataset_salas
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true
            }
          }]
        },
        events: ['click'],
        legend: { display: true },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  getBingosFacturacion() {
    if(this.chart1) { this.chart1.destroy(); }
    if(this.chart2) { this.chart2.destroy(); }

    this.rest.getBingosFacturacion(this.date_desde, this.date_hasta).subscribe( (data) => {

      const arr_dataset = [];
      const arr_dataset_acum = [];

      for (let index = 0; index < data['data'].length; index++) {
          arr_dataset.push({
            label: data['data'][index]['sala'],
            backgroundColor: data['data'][index]['color'],
            borderColor: data['data'][index]['color'],
            data: data['data'][index]['facturacion'],
            fill: false,
            hoverBorderWidth: 1,
            hidden: false
          });
          arr_dataset_acum.push({
            label: data['data'][index]['sala'],
            backgroundColor: data['data'][index]['color'],
            borderColor: data['data'][index]['color'],
            data: data['data'][index]['acumulado'],
            fill: false,
            hoverBorderWidth: 1,
            hidden: false
          });
      }

      this.chart1 = this.mixedChart('mix1', 'Facturación Bingos', data['data'][0]['fecha'], arr_dataset);
      this.chart2 = this.mixedChart('mix2', 'Facturación Bingos Acumulado', data['data'][0]['fecha'], arr_dataset_acum);
    });
  }

  changeChart(type) {
    this.chart1.config.type = type;
    this.chart2.config.type = type;
    this.chart1.update();
    this.chart2.update();
  }

  clickchart(event){
    console.log(event);
    this.chart1.beforeEvent();
  }



}
